import { render, staticRenderFns } from "./CategoryModule.vue?vue&type=template&id=283295bc&"
import script from "./CategoryModule.vue?vue&type=script&lang=js&"
export * from "./CategoryModule.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CategoryModule.vue"
export default component.exports